// @ts-check
import React from "react";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { useAISidebar } from "src/hooks/useAISidebar";
import { AIChatV3Window } from "../AIContent";

export const AINav = () => {
  const { enableAIChat, enableAskTeamformV2 } = useWorkspaceFeatureFlags();

  const { isOpen } = useAISidebar();

  // The consolidated pane is also the v2 dashboard/chat surface, so v2
  // workspaces need it even when the standalone AI chat flag is off.
  if (!enableAIChat && !enableAskTeamformV2) {
    return null;
  }

  return <AIChatV3Window isOpen={isOpen} />;
};
